export default abstract class Model<T> {
    readonly data: T;

    public constructor(data: T) {
        this.data = data;
    }
}
